import styled from 'styled-components';
import Link from 'next/link';
import Grid from 'styled-components-grid';
import {media} from '../lib/theme';

const StyledGrid = styled(Grid)``;

const StyledGridUnit = styled(Grid.Unit)``;

const Line1 = styled.h4`
  margin: 0;
  text-transform: uppercase;
  font-weight: bold;
  font-size: ${({theme}) => theme.fontSize.default};
`;

const Line2 = styled.div`
  margin-top: ${({theme}) => theme.spacing.default};
  font-size: ${({theme}) => theme.fontSize.small};
`;

const ListImage = styled.div`
  background-image: ${({image}) => (image ? `url(${image})` : null)};
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  padding-bottom: 150px;
  ${media.sm`
    padding-bottom: 100%;
  `}
`;

const ListWrapper = styled.div`
  width: 100%;
`;

const ListItem = styled.a`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  text-decoration: none;
  color: unset;
  margin-bottom: ${({theme}) => theme.spacing.default};
  background-color: ${({theme}) => theme.colors.lightgrayOverlay};
  &:last-child {
    margin-bottom: 0px;
  }
  &:hover {
    text-decoration: unset;
    color: unset;
    & h4 {
      color: ${({theme}) => theme.colors.green};
    }
  }
`;

const ListItemContent = styled.div`
  padding: ${({theme}) => theme.spacing.default};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const List = ({items}) => (
  <ListWrapper>
    {items?.map(({line1, line2, image, link, as}, index) => (
      <Link key={index} href={link} as={as} passHref>
        <ListItem>
          <StyledGrid>
            <StyledGridUnit size={{xs: 1, sm: 1 / 4, md: 1 / 6}}>
              <ListImage image={image} />
            </StyledGridUnit>
            <StyledGridUnit size={{xs: 1, sm: 3 / 4, md: 5 / 6}}>
              <ListItemContent>
                <Line1>{line1}</Line1>
                {line2 && <Line2>{line2}</Line2>}
              </ListItemContent>
            </StyledGridUnit>
          </StyledGrid>
        </ListItem>
      </Link>
    ))}
  </ListWrapper>
);

export default List;
